"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContextState = exports.useSetContext = exports.useValueContext = exports.createStateContext = exports.createDispatcherContext = exports.createValueContext = void 0;
const react_1 = require("react");
const createValueContext = (value) => {
    const valueContext = (0, react_1.createContext)(value);
    valueContext.displayName = "valueContext";
    return valueContext;
};
exports.createValueContext = createValueContext;
const createDispatcherContext = (dispatcher) => {
    const dispatcherContext = (0, react_1.createContext)(dispatcher);
    dispatcherContext.displayName = "setContext";
    return dispatcherContext;
};
exports.createDispatcherContext = createDispatcherContext;
const createStateContext = (state) => {
    const stateContext = (0, react_1.createContext)(state);
    stateContext.displayName = "stateContext";
    return stateContext;
};
exports.createStateContext = createStateContext;
const useValueContext = (valueCtx) => {
    const context = (0, react_1.useContext)(valueCtx);
    return context;
};
exports.useValueContext = useValueContext;
const useSetContext = (dispatcherCtx) => {
    const context = (0, react_1.useContext)(dispatcherCtx);
    return context;
};
exports.useSetContext = useSetContext;
const useContextState = (stateCtx) => {
    const context = (0, react_1.useContext)(stateCtx);
    return context;
};
exports.useContextState = useContextState;
